export default {"src":"/_next/static/media/premium-expansion-sweden-hero.f5227cd3.svg","height":154,"width":300,"blurWidth":0,"blurHeight":0};